import axios from "axios";
import { baseUrl } from "../http/api-configuration";
import store from "../../../store";
import { logout } from "../../../store/slices/userSlice";

export const axiosInstance = axios.create({
	baseURL: baseUrl, // Corrected assignment of baseURL
	timeout: 5000,
	headers: {
		"Content-Type": "application/json",
	},
});

axiosInstance.interceptors.request.use(
	(config) => {
		const user = JSON.parse(localStorage.getItem("user") || "{}");
		if (user.token) {
			config.headers["Authorization"] = `Bearer ${user.token}`;
		} else {
			delete config.headers["Authorization"];
		}
		const url = new URL(config.url, config.baseURL);
		url.searchParams.append("program_id", 2);
		config.url = url.toString().replace(config.baseURL, "");
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

axiosInstance.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		if (error.response && error.response.status === 401) {
			store.dispatch(logout());
			localStorage.clear();
			console.log("Unauthorized");
		}
		return Promise.reject(error);
	}
);

export default axiosInstance;
